import { Component, effect, signal } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ButtonComponent } from '@libs/front/components/button/button.component';
import { DataTableComponent, TableColumn } from '@libs/front/components/data-table/data-table.component';
import { TranslateModule } from '@ngx-translate/core';
import { DrillPauseReason } from 'src/app/bo/drill-pause-reason';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { DrillPauseReasonModalComponent } from '../drill-pause-reason-modal/drill-pause-reason-modal.component';

@Component({
  selector: 'app-drill-pause-reasons',
  templateUrl: './drill-pause-reasons.component.html',
  styleUrls: ['./drill-pause-reasons.component.scss'],
  standalone: true,
  imports: [ButtonComponent, DataTableComponent, TranslateModule],
})
export class DrillPauseReasonsComponent {
  readonly reasons = signal<DrillPauseReason[]>([]);
  readonly erreurRecuperation = signal(false);
  modale: BsModalRef;

  readonly tableColumns: TableColumn[] = [
    { key: 'title',       label: 'GLOBAL.TITLE' },
    { key: 'description', label: 'GLOBAL.DESCRIPTION' },
    { key: 'color',       label: 'GLOBAL.COLOR' },
  ];

  constructor(
    private readonly modalService: BsModalService,
    private readonly http: HttpService,
    private readonly fonctionsService: FonctionsService,
    protected readonly utilService: UtilisateurService,
  ) {
    effect(() => { this.utilService.currentSite(); this.refreshData(); });
  }

  private refreshData() {
    this.erreurRecuperation.set(false);
    this.reasons.set([]);
    const siteId = this.utilService.currentSite()?.siteId;
    if (!siteId) return;

    this.http.get<DrillPauseReason[]>(`DrillSessions/pausereasons/site/${siteId}`).subscribe({
      next: (data) => this.reasons.set(data),
      error: () => this.erreurRecuperation.set(true),
    });
  }

  protected openEditModal(reason: DrillPauseReason) {
    const initialState = {
      reason: { ...reason },
      isEdit: true,
    };
    this.modale = this.modalService.show(DrillPauseReasonModalComponent, {
      backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState,
    });
    this.modale.content.dataEmitter.subscribe({
      next: (updated: DrillPauseReason) => {
        this.reasons.update(arr =>
          arr.map(r => r.drillPauseReasonId === updated.drillPauseReasonId ? updated : r)
        );
      },
      error: () => this.reasons.update(arr => arr.filter(r => r.drillPauseReasonId !== reason.drillPauseReasonId)),
    });
    this.modale.content.deleteEmitter.subscribe({
      next: (id: number) => this.reasons.update(arr => arr.filter(r => r.drillPauseReasonId !== id)),
    });
  }

  protected openAddModal() {
    const initialState = {
      reason: { drillPauseReasonId: 0, siteId: this.utilService.currentSite().siteId, title: '', description: '', color: '#000000' },
      isEdit: false,
    };
    this.modale = this.modalService.show(DrillPauseReasonModalComponent, {
      backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState,
    });
    this.modale.content.dataEmitter.subscribe({
      next: (created: DrillPauseReason) => this.reasons.update(arr => [...arr, created]),
    });
  }
}
